import React, {useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {Container, Row, Col, Form} from 'react-bootstrap';
import axios from '../utils/axios';
import Compressor from 'compressorjs';


function AdvertisementModal({sponsorCode}) {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
        setImage('');
        setFile(null);
    }
    const handleShow = () => setShow(true);
    const [image, setImage] = useState('');
    const [file, setFile] = useState(null);

    const onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            let img = event.target.files[0];
            let imageURL = URL.createObjectURL(img);
            setImage(imageURL);
            new Compressor(img, {
                quality: 0.2, // 0.6 can also be used, but its not recommended to go below.
                success: (compressedResult) => {
                  setFile(compressedResult);
                  // console.log('img compressesd', compressedResult.size/1024/1024)
                }
            });
            // setFile(img);
        }
    };

    const handleSubmit = () => {
        if (file != null && image != '') {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("SponsorCode", sponsorCode);
            axios.post(
                "ad/adregister", formData, {
                    headers: {
                        // Multer only parses "multipart/form-data" requests
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    console.log(response);
                    setTimeout(() => {
                        toast("Ad Published successfully");
                        handleClose();
                        window.location.reload();
                    }, 1000);
                })
                .catch((e) => {
                    toast("Ad Could not be published!");
                });
        } else {
            toast("Please select an image first!");
        }
    };

    return (
        <>
            <ToastContainer/>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Button color="dark" width="30%" onClick={handleShow}>Add Advertisement</Button>
            </div>
            <Modal size="lg" show={show} onHide={handleClose} style={{zIndex: '1200'}}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Advertisement</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                    <Form.Label>Choose Image</Form.Label>
                                    <Form.Control type="file" accept='image/png, image/jpeg'
                                                  placeholder="Add Ad Image"
                                                  onChange={onImageChange}/>
                                    <Form.Text style={{color: 'red'}}>
                                        *Image should be Landscape Size 120*300.
                                    </Form.Text>
                                </Form.Group>
                            </Col>
                            <Col>
                                {
                                    image ?
                                        <div style={{textAlign: 'right'}}>
                                            <img src={image} width="200px"/>
                                        </div>
                                        :
                                        ''
                                }
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Publish Ad
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AdvertisementModal;